import { useMutation } from '@tanstack/react-query';
import { SearchApiCreatorsRequestParams, searchCreatorApi } from '~/searchApi';

export const useGetCreatorUpdatedByFilter = () => {
  return useMutation((filters: SearchApiCreatorsRequestParams) =>
    searchCreatorApi.getCreators(filters),
  );
};
